import { BotevoDesignTokens } from "../../../assets/themes/botevoPreset";

export const BAR_COLORS = [
  BotevoDesignTokens.primitive?.green?.[50],
  BotevoDesignTokens.primitive?.blue?.[200],
  BotevoDesignTokens.primitive?.green?.[400],
  BotevoDesignTokens.primitive?.green?.[600],
  BotevoDesignTokens.primitive?.blue?.[50],
  BotevoDesignTokens.primitive?.green?.[800],
  BotevoDesignTokens.primitive?.blue?.[300],
  BotevoDesignTokens.primitive?.green?.[900],
  BotevoDesignTokens.primitive?.blue?.[800],
];
